module.exports = __webpack_public_path__ + "static/img/solidwork1.9f36c7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/develop/solidwork/solidwork1.jpg
// module id = URGE
// module chunks = 0